import SEO from "@/components/SEO";
import { canonical } from "@/utils/seo";

const eventTitle = "政大辦桌彩妝小站｜美好時光快閃";

export default function NccuMakeupEvent() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        meta={{
          title: `${eventTitle}｜美好時光指南`,
          description:
            "2026年5月24日，美好時光指南走進政大校園，在辦桌文化節現場設立彩妝小站，提供免費妝容諮詢、快速補妝與彩妝試色體驗。",
          canonical: canonical("/events/nccu-makeup-station-2026"),
          keywords: [
            "政大辦桌",
            "政大彩妝",
            "美好時光指南",
            "校園彩妝",
            "快閃體驗",
            "NCCU",
          ],
          ogType: "article",
        }}
      />

      {/* Hero */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20lively%20outdoor%20campus%20beauty%20pop-up%20event%20at%20a%20Taiwanese%20university%20during%20spring%20festival%2C%20featuring%20a%20stylish%20white%20and%20blush%20pink%20makeup%20booth%20tent%20with%20warm%20rose%20gold%20accents%2C%20professional%20makeup%20artists%20applying%20makeup%20on%20students%20at%20wooden%20vanity%20stations%20with%20round%20mirrors%20and%20soft%20ring%20lights%2C%20colorful%20lipstick%20and%20eyeshadow%20palettes%20displayed%20on%20marble%20trays%2C%20cheerful%20young%20attendees%20holding%20handheld%20mirrors%2C%20lush%20green%20campus%20trees%20and%20traditional%20red%20festival%20decorations%20in%20soft%20bokeh%20background%2C%20lifestyle%20event%20photography%20with%20warm%20golden%20hour%20lighting%2C%20no%20text%20no%20logos%2C%20elegant%20and%20youthful%20atmosphere%20with%20cream%20rose%20and%20sage%20green%20tones&width=1440&height=600&seq=nccu-makeup-hero-v1&orientation=landscape"
          alt="政大辦桌彩妝小站活動主視覺"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold rounded-full mb-4 tracking-wide">
            2026.5/24 限定一日
          </span>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 tracking-tight">
            政大辦桌彩妝小站
          </h1>
          <p className="text-base md:text-lg text-white/90 max-w-xl">
            美好時光走進校園 · 免費妝容諮詢 · 彩妝試色體驗
          </p>
        </div>
      </section>

      {/* Event Info */}
      <section className="w-full px-4 md:px-8 lg:px-14 py-10 md:py-16">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {/* Left: Info Cards */}
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-2">
                  在政大，遇見更美的自己
                </h2>
                <p className="text-slate-500 text-sm">
                  GoldenTimeGuides × 政大辦桌文化節 限定快閃
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-stone-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-rose-100 text-rose-700 mb-3">
                    <i className="ri-calendar-line text-lg" />
                  </div>
                  <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">
                    活動日期
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    2026.5/24（六）
                  </p>
                  <p className="text-xs text-slate-500 mt-1">10:00 — 18:00</p>
                </div>

                <div className="bg-stone-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-rose-100 text-rose-700 mb-3">
                    <i className="ri-map-pin-line text-lg" />
                  </div>
                  <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">
                    活動地點
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    國立政治大學 四維堂廣場
                  </p>
                  <p className="text-xs text-slate-500 mt-1">台北市文山區</p>
                </div>

                <div className="bg-stone-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-rose-100 text-rose-700 mb-3">
                    <i className="ri-ticket-line text-lg" />
                  </div>
                  <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">
                    入場方式
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    免費體驗
                  </p>
                  <p className="text-xs text-slate-500 mt-1">
                    現場排隊，每人限一次
                  </p>
                </div>

                <div className="bg-stone-50 rounded-xl p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-rose-100 text-rose-700 mb-3">
                    <i className="ri-heart-3-line text-lg" />
                  </div>
                  <p className="text-xs text-slate-400 font-medium uppercase tracking-wider mb-1">
                    活動亮點
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    3 大體驗區
                  </p>
                  <p className="text-xs text-slate-500 mt-1">
                    諮詢、試色、改妝
                  </p>
                </div>
              </div>

              <div className="bg-white border border-slate-100 rounded-xl p-6">
                <h3 className="text-lg font-bold text-slate-800 mb-3">
                  彩妝小站有什麼？
                </h3>
                <ul className="space-y-3">
                  {[
                    {
                      icon: "ri-user-voice-line",
                      title: "個人妝容諮詢",
                      desc: "分析你的五官輪廓，推薦最適合的妝容風格",
                    },
                    {
                      icon: "ri-brush-line",
                      title: "免費試色體驗",
                      desc: "專櫃級彩妝品牌全色號現場試用",
                    },
                    {
                      icon: "ri-magic-line",
                      title: "快速改妝服務",
                      desc: "現場幫你微調底妝、補眉、補唇彩",
                    },
                    {
                      icon: "ri-gift-line",
                      title: "打卡好禮",
                      desc: "拍照打卡即贈品牌小樣與優惠券",
                    },
                  ].map((item) => (
                    <li key={item.title} className="flex items-start gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-md bg-rose-50 text-rose-600 shrink-0 mt-0.5">
                        <i className={`${item.icon} text-sm`} />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-slate-800">
                          {item.title}
                        </p>
                        <p className="text-xs text-slate-500">{item.desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Right: Image + Description */}
            <div className="space-y-6">
              <div className="rounded-xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20close-up%20of%20an%20elegant%20makeup%20artists%20workstation%20at%20an%20outdoor%20pop-up%20beauty%20event%20on%20a%20Taiwanese%20university%20campus%2C%20featuring%20a%20round%20vanity%20mirror%20with%20warm%20ring%20light%2C%20neatly%20arranged%20lipsticks%20in%20nude%20and%20rose%20shades%2C%20a%20small%20bouquet%20of%20dried%20flowers%2C%20a%20handheld%20makeup%20brush%20set%20on%20a%20blush%20pink%20linen%20cloth%2C%20soft%20natural%20daylight%20filtering%20through%20trees%2C%20lifestyle%20beauty%20photography%20with%20warm%20rose%20cream%20and%20soft%20green%20tones%2C%20no%20text%20no%20logos%2C%20inviting%20and%20professional%20atmosphere&width=800&height=600&seq=nccu-makeup-detail-v1&orientation=landscape"
                  alt="彩妝小站攤位示意"
                  className="w-full h-full object-cover object-center"
                />
              </div>

              <div className="bg-stone-50 rounded-xl p-6">
                <h3 className="text-lg font-bold text-slate-800 mb-3">
                  活動介紹
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-4">
                  美好時光指南首次走進校園！在政大一年一度的「辦桌文化節」現場，我們搭起了一座夢幻彩妝小站。不用花錢、不用預約，只要帶著好奇心走過來，就能享受專業級的妝容諮詢與試色體驗。
                </p>
                <p className="text-sm text-slate-600 leading-relaxed">
                  現場集結了平台上評價最高的彩妝品牌與造型師，從日常淡妝到派對妝容，從膚色分析到風格定位，幫你在 15 分鐘內找到最適合自己的那一款。還可以和同學一起拍照打卡，領取品牌限定小樣禮包！
                </p>
              </div>

              <div className="bg-rose-50 border border-rose-100 rounded-xl p-5">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-rose-100 text-rose-700 shrink-0">
                    <i className="ri-bus-line text-base" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-slate-800">
                      交通方式
                    </p>
                    <p className="text-xs text-slate-600 mt-1 leading-relaxed">
                      捷運萬芳社區站轉公車至政治大學站 · 校內活動中心前廣場
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Embed Section */}
      <section className="w-full px-4 md:px-8 lg:px-14 py-10 md:py-16 bg-stone-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-2">
              活動報名與回饋
            </h2>
            <p className="text-sm text-slate-500">
              歡迎填寫表單報名限定體驗，或留下你對彩妝小站的想法
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
            <iframe
              src="https://readdy.ai/preview/915be1ab-6d61-4807-b162-ef06b46c1e0c/9755388/feedback"
              width="100%"
              height="900"
              title="政大辦桌彩妝小站活動報名表單"
              frameBorder="0"
              style={{ borderRadius: "12px", overflow: "hidden" }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}